import api from "./api";

/**
 * Servicio para interactuar con la API de Ventas
 */
const saleService = {
  /**
   * Obtener lista de ventas con filtros
   */
  getAll: async (params = {}) => {
    const response = await api.get("/sales", { params });
    return response.data;
  },

  /**
   * Obtener una venta por ID
   */
  getById: async (id) => {
    const response = await api.get(`/sales/${id}`);
    return response.data;
  },

  /**
   * ✅ CORREGIDO: Obtener ventas elegibles para nota de crédito
   * (Ventas con factura VALIDADA tipo 03 y sin nota de crédito activa)
   */
  getEligibleForCreditNote: async (searchTerm = "") => {
    try {
      // ✅ CORREGIDO: Usar el endpoint correcto
      const response = await api.get("/invoices/elegibles-nota-credito", {
        params: {
          search: searchTerm,
        },
      });
      
      console.log("📡 Respuesta del backend (elegibles):", response.data);
      
      // El backend ya devuelve las ventas filtradas correctamente
      const salesData = response.data;
      
      console.log("✅ Total ventas elegibles del backend:", salesData?.length || 0);
      
      // El backend ya hace todo el filtrado, solo devolvemos los datos
      return { data: Array.isArray(salesData) ? salesData : [] };
      
    } catch (error) {
      console.error("❌ Error obteniendo ventas elegibles:", error);
      console.error("❌ Response data:", error.response?.data);
      throw error;
    }
  },

  getEligibleForDebitNote: async (searchTerm = "") => {
    try {
      const response = await api.get("/invoices/elegibles-nota-debito", {
        params: { search: searchTerm },
      });
      const salesData = response.data;
      return { data: Array.isArray(salesData) ? salesData : [] };
    } catch (error) {
      console.error("❌ Error obteniendo ventas elegibles para débito:", error);
      throw error;
    }
  },
};

export default saleService;